// extracted by mini-css-extract-plugin
module.exports = {"list":"NavbarLinks_list__3xDNx","link":"NavbarLinks_link__xrYer","button":"NavbarLinks_button__1ya6j","user":"NavbarLinks_user__Sf4qy"};